import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectListboxService {
  private activeSelectListbox$$ = new BehaviorSubject<string | null>(null);

  constructor() {}

  get activeSelectListbox$(): Observable<string | null> {
    return this.activeSelectListbox$$
      .asObservable()
      .pipe(distinctUntilChanged());
  }

  public setActiveSelectListbox(value: string): void {
    this.activeSelectListbox$$.next(value);
  }

  public close(): void {
    this.activeSelectListbox$$.next(null);
  }
}
